import ArrowForward from '@mui/icons-material/ArrowForward';
import Close from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import { useTheme } from '@mui/material';
import MiraLogo from '../../../assets/images/logo/Mira-Logo_Mira-Only_Black.svg?react';
import { logEvent } from '@/util/logger';
import { LOG_MESSAGES } from '@/constants/logMessages';
import { useContext } from 'react';
import { UserContext } from '@/providers/userContextProvider';
import { ThemedTooltip } from '@/components/chat/FeedbackContainer';
import { useTranslation } from 'react-i18next';

type props = {
  mobileOpen: boolean;
  setMobileOpen: (open: boolean) => void;
  setManuallyClosed: (closed: boolean) => void;
};
const LogoContainer: React.FC<props> = ({
  mobileOpen,
  setMobileOpen,
  setManuallyClosed,
}) => {
  const { t } = useTranslation(['navMenu']);
  const theme = useTheme();
  const { closed, setClosed } = useContext(UserContext);
  const show = closed && !mobileOpen;
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '24px',
        pt: 1.5,
        height: '64px',
      }}
    >
      <MiraLogo
        data-testid="sidebar-logo"
        style={{
          marginTop: 2,
          marginLeft: show ? '0px' : '20px',
          opacity: show ? 0 : 1,
          height: 'auto',
          width: show ? '0px' : '64px',
          transition: 'all .5s ease',
        }}
        color={theme.palette.mode !== 'dark' ? '#000000' : '#ffffffff'}
      />

      <ThemedTooltip
        title={t(!closed ? 'close' : 'open')}
        placement="right"
        data-testid="toggle-sidebar-tooltip"
      >
        <Box
          sx={{
            px: closed ? '10px' : '4px',
            width: closed ? '100%' : 'max-content',
          }}
        >
          <IconButton
            data-testid="sidebar-toggle-button"
            onClick={() => {
              logEvent(LOG_MESSAGES.USER_CLICKED_SIDEBAR_ARROW, {
                verdict: closed
                  ? 'They opened the sidebar'
                  : 'They closed the sidebar',
              });
              setClosed(!closed);
              setMobileOpen(false);
              setManuallyClosed(closed);
            }}
            size="small"
            sx={{
              fontSize: '12px',
              m: !closed ? 1 : 0,
              display: {
                xs: 'none',
                sm: 'none',
                md: 'none',
                lg: 'block',
              },
            }}
          >
            <ArrowForward
              sx={{
                transform: !closed ? 'rotate(180deg)' : undefined,
                transition: 'all .5s ease',
                color: theme.palette.primary.main,
              }}
            />
          </IconButton>
        </Box>
      </ThemedTooltip>
      <IconButton
        data-testid="sidebar-close-button"
        onClick={() => setMobileOpen(false)}
        size="small"
        sx={{
          fontSize: '12px',
          m: 1,
          display: { lg: 'none' },
        }}
      >
        <Close
          sx={{
            color: theme.palette.primary.main,
          }}
        />
      </IconButton>
    </Box>
  );
};

export default LogoContainer;
